<script>
  import { fade } from 'svelte/transition';
</script>

<!-- Have to fix height for mobile later because of chrome navbar -->
<div
  class="flex flex-col items-center justify-center flex-grow fixed top-0 left-0 w-full h-screen overflow-y-auto bg-[#111111BF] z-[1000] backdrop-blur-md"
  transition:fade|global={{ duration: 50 }}
>
  <div class="w-full h-full">
    <slot />
  </div>
</div>
